// src/components/AdminDashboard/sections/CourtCoOwnerSection.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Typography, MenuItem, FormControl, Select, InputLabel, Button } from '@mui/material';

const CourtCoOwnerSection = ({
  courts,
  users,
  loadingUsers,
  selectedCourt,
  setSelectedCourt,
  selectedCoOwner,
  setSelectedCoOwner,
  handleAddCourtCoOwner,
  loadingAddCoOwner
}) => {
  console.log('CourtCoOwnerSection rendered with props:', {
    courts: courts?.length,
    users: users?.length,
    loadingUsers,
    selectedCourt,
    selectedCoOwner
  });
  
  return (
    <div className="bg-gradient-to-br from-white to-gray-50/50 rounded-2xl p-8 mb-8 shadow-lg border border-gray-100 hover:shadow-xl hover:border-[#00a693]/20 transition-all duration-300 hover:-translate-y-1 relative overflow-hidden before:content-[''] before:absolute before:top-0 before:left-0 before:right-0 before:h-1 before:bg-gradient-to-r before:from-[#00a693] before:to-[#ff6f3c] before:opacity-0 hover:before:opacity-100 before:transition-opacity before:duration-300">
      {/* Section Header */}
      <div className="flex justify-between items-center mb-6 pb-4 border-b-2 border-[#00a693]/10">
        <div>
          <Typography variant="h6" className="text-[#00a693] font-bold text-xl mb-2">
            🆕 Add Court Co-Owner (NEW!)
          </Typography>
          <Typography variant="body2" className="text-[#666666] text-sm">
            Add a co-owner to an existing court. Co-owners have the same permissions as the primary owner.
          </Typography>
        </div>
      </div>

      {/* Form */}
      <form onSubmit={handleAddCourtCoOwner} className="flex flex-col gap-6 max-w-2xl p-6 bg-gradient-to-br from-[#00a693]/5 to-[#ff6f3c]/5 rounded-xl border border-[#00a693]/10">
        {/* Court Selection */}
        <FormControl variant="outlined" required className="w-full">
          <InputLabel 
            id="select-court-co-owner-label" 
            className="text-[#5a7684] font-semibold [&.Mui-focused]:text-[#00a693]"
          >
            Select Court
          </InputLabel>
          <Select
            labelId="select-court-co-owner-label"
            value={selectedCourt}
            label="Select Court"
            onChange={(e) => setSelectedCourt(e.target.value)}
            className="[&_.MuiOutlinedInput-notchedOutline]:border-gray-300 [&_.MuiOutlinedInput-notchedOutline]:rounded-lg hover:[&_.MuiOutlinedInput-notchedOutline]:border-[#00a693] focus:[&_.MuiOutlinedInput-notchedOutline]:border-[#00a693] focus:[&_.MuiOutlinedInput-notchedOutline]:shadow-[0_0_0_2px_rgba(0,166,147,0.2)]"
          >
            {courts.length === 0 ? (
              <MenuItem value="">
                <em>No courts found</em>
              </MenuItem>
            ) : (
              courts.map((court) => (
                <MenuItem key={court.courtId} value={court.courtId}>
                  {court.courtName} ({court.courtId})
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>

        {/* Co-Owner Selection */}
        <FormControl variant="outlined" required className="w-full">
          <InputLabel 
            id="select-co-owner-label" 
            className="text-[#5a7684] font-semibold [&.Mui-focused]:text-[#00a693]"
          >
            Select Co-Owner
          </InputLabel>
          <Select
            labelId="select-co-owner-label"
            value={selectedCoOwner}
            label="Select Co-Owner"
            onChange={(e) => setSelectedCoOwner(e.target.value)}
            className="[&_.MuiOutlinedInput-notchedOutline]:border-gray-300 [&_.MuiOutlinedInput-notchedOutline]:rounded-lg hover:[&_.MuiOutlinedInput-notchedOutline]:border-[#00a693] focus:[&_.MuiOutlinedInput-notchedOutline]:border-[#00a693] focus:[&_.MuiOutlinedInput-notchedOutline]:shadow-[0_0_0_2px_rgba(0,166,147,0.2)]"
          >
            {loadingUsers ? (
              <MenuItem value="">
                <em>Loading...</em>
              </MenuItem>
            ) : (
              users && Array.isArray(users) && users.map((user) => (
                <MenuItem key={user.id} value={user.username}>
                  {user.username} ({user.email})
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>

        {/* Submit Button */}
        <Button 
          type="submit" 
          variant="contained" 
          disabled={loadingAddCoOwner}
          className="bg-gradient-to-r from-[#BD2026] to-[#ff6f3c] hover:from-[#ff6f3c] hover:to-[#BD2026] text-white rounded-lg px-8 py-3 font-bold text-sm tracking-wide shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 disabled:from-gray-300 disabled:to-gray-400 disabled:transform-none disabled:shadow-none"
        >
          {loadingAddCoOwner ? 'Adding Co-Owner...' : 'Add Co-Owner'}
        </Button>
      </form>
    </div>
  );
};

CourtCoOwnerSection.propTypes = {
  courts: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,
  loadingUsers: PropTypes.bool.isRequired,
  selectedCourt: PropTypes.string.isRequired,
  setSelectedCourt: PropTypes.func.isRequired,
  selectedCoOwner: PropTypes.string.isRequired,
  setSelectedCoOwner: PropTypes.func.isRequired,
  handleAddCourtCoOwner: PropTypes.func.isRequired,
  loadingAddCoOwner: PropTypes.bool.isRequired
};

export default CourtCoOwnerSection;
